import { combineReducers } from 'redux'

// V3
import AdminReducer, {
  initialState as adminSlice,
} from 'src/v3/admin/admin.slice'
import ClassroomReducer, {
  initialState as classroomSlice,
} from 'src/v3/classroom/classroom.slice'
import ClassroomV2Reducer, {
  initialState as classroomV2Slice,
} from 'src/v3/classroom-v2/classroom-v2.slice'
import ClassroomV2WizardReducer, {
  initialState as classroomV2WizardSlice,
} from 'src/v3/classroom-v2/classroom-v2-wizard.slice'
import CodexReducer, {
  initialState as codexSlice,
} from 'src/v3/codex/codex.slice'
import CreateReducer, {
  initialState as createSlice,
} from 'src/v3/create/create.slice'
import CreateV5Reducer, {
  initialState as createV5Slice,
} from 'src/v3/create/v5/create.slice'
import ManageReducer, {
  initialState as manageSlice,
} from 'src/v3/manage/manage.slice'
import ManageComplianceReducer from 'src/v3/manage/compliance.slice'
import ManageEventsReducer, {
  initialState as manageEventsSlice,
} from 'src/v3/manage/events/manage-events.slice'
import EventsReducer, {
  initialState as eventsSlice,
} from 'src/v3/events/events.slice'
import EventsV2Reducer, {
  initialState as eventsV2Slice,
} from 'src/v3/events/v2/events-v2.slice'
import AccreditationReducer, {
  initialState as accreditationSlice,
} from 'src/v3/content-pipeline/accreditation.slice'
import AccreditationHealthReducer from 'src/v3/content-pipeline/accreditation-health.slice'
import CoursePipelineReducer from 'src/v3/content-pipeline/course-pipeline.slice'
import EventPipelineReducer from 'src/v3/content-pipeline/event-pipeline.slice'
import InstructorReducer, {
  initialState as instructorSlice,
} from 'src/v3/content-pipeline/instructor.slice'
import PerformanceReducer, {
  initialState as performanceSlice,
} from 'src/v3/content-pipeline/performance.slice'
import ProfileReducer, {
  initialState as profileSlice,
} from 'src/v3/profile/profile.slice'
import ScribeReducer, {
  initialState as scribeSlice,
} from 'src/v3/scribe/scribe.slice'
import SelfPacedReducer, {
  initialState as selfPacedSlice,
} from 'src/v3/self-paced/self-paced.slice'
import SettingsReducer, {
  initialState as settingsSlice,
} from 'src/v3/settings/settings.slice'
import ToursReducer, {
  initialState as toursSlice,
} from 'src/v3/tours/tours.slice'
import AnalyticsReducer, {
  initialState as analyticsSlice,
} from 'src/v3/manage/analytics/advanced-activity-dashboard/analytics.slice'
import MotherReducer, {
  initialState as motherSlice,
} from 'src/v3/admin/mother/mother.slice'
import IBSCReducer, {
  initialState as ibscSlice,
} from 'src/v3/profile/v4/ibsc/ibsc.slice'
// OLD: Removed userActivity slice - replaced by Timeline V2 with React Query

const rootReducer = combineReducers({
  accreditation: AccreditationReducer,
  accreditationHealth: AccreditationHealthReducer,
  admin: AdminReducer,
  analytics: AnalyticsReducer,
  classroom: ClassroomReducer,
  classroomV2: ClassroomV2Reducer,
  classroomV2Wizard: ClassroomV2WizardReducer,
  codex: CodexReducer,
  coursePipeline: CoursePipelineReducer,
  create: CreateReducer,
  createV5: CreateV5Reducer,
  eventPipeline: EventPipelineReducer,
  ibsc: IBSCReducer,
  instructor: InstructorReducer,
  manage: ManageReducer,
  manageCompliance: ManageComplianceReducer,
  manageEvents: ManageEventsReducer,
  events: EventsReducer,
  eventsV2: EventsV2Reducer,
  performance: PerformanceReducer,
  profile: ProfileReducer,
  scribe: ScribeReducer,
  selfPaced: SelfPacedReducer,
  settings: SettingsReducer,
  tours: ToursReducer,
  mother: MotherReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export const rootInitialState: Omit<
  RootState,
  | 'accreditationHealth'
  | 'coursePipeline'
  | 'eventPipeline'
  | 'manageCompliance'
> = {
  accreditation: accreditationSlice,
  admin: adminSlice,
  analytics: analyticsSlice,
  classroom: classroomSlice,
  classroomV2: classroomV2Slice,
  classroomV2Wizard: classroomV2WizardSlice,
  codex: codexSlice,
  create: createSlice,
  createV5: createV5Slice,
  ibsc: ibscSlice,
  instructor: instructorSlice,
  manage: manageSlice,
  manageEvents: manageEventsSlice,
  events: eventsSlice,
  eventsV2: eventsV2Slice,
  performance: performanceSlice,
  profile: profileSlice,
  scribe: scribeSlice,
  selfPaced: selfPacedSlice,
  settings: settingsSlice,
  tours: toursSlice,
  mother: motherSlice,
}

export default rootReducer
